export function checkUrl(value){
  try {
    const url = new URL(value);
    if (url.protocol.toLowerCase() === 'https:' || url.protocol.toLowerCase() === 'http:') 
      return true;
    else return false;
  } catch (error) {
    return false;
  }
}

export function getConfTitan(conf, data, model) {
  const srv = data?.eec_data?.refs?.find(m=>m.type==='SERVICE');
  const mserv = model?.refs.find(m=>m.type === 'SERVICE') ?? {};
  conf.enable= data?.eec_is_enable || false;
  conf.ext_uri = data?.eec_data?.ext_uri || model.ext_uri;
  conf.apikey= data?.eec_data?.api_key || model.api_key;
  conf.apilogin= data?.eec_data?.login || model.login;
  conf.apipassword= data?.eec_data?.password || model.password;
  conf.apiurl= data?.eec_data?.api_url || model.api_url;
  conf.enable_pull_event = data?.eec_data?.enable_pull_event; // No need to replace by model value, undefined is a valid value
  conf.enable_push_activity= data?.eec_data?.enable_push_activity;
  conf.enable_push_patgames= data?.eec_data?.enable_push_patgames;
  conf.metiers= data?.eec_data?.refs?.find(m=> m.type === 'JOB')?.mappings || model.refs.find(m=> m.type === 'JOB').mappings;
  conf.service= {
      source: srv?.source || mserv.source,
      default: srv?.default_id || mserv.default_id
    };
  conf.jobsfilter= data?.eec_data?.filter?.find(f=>f.type === 'STAFF')?.include || model.filter.find(f=>f.type === 'STAFF').include;
  conf.datainitial= data?.eec_data
  conf.ctx = data?.eec_id
  const push = data?.eec_data?.feature?.push;
  conf.push = push || model.feature.push;
  conf.saved = !!(data?.eec_data)
  return conf;
}

export function setDataTitanFromConf(conf, model){
  // clone du model sinon même référence
  const data = {...model};
  const srv = data.refs.find(m=>m.type==='SERVICE')
  srv.source = conf.service.source;
  srv.default_id = conf.service.default;

  data.refs.find(m=> m.type === 'JOB').mappings = conf.metiers;
  data.filter.find(f=>f.type === 'STAFF').include = conf.jobsfilter;
  data.api_key = conf.apikey;
  data.ext_uri = conf.ext_uri;
  data.login = conf.apilogin;
  data.password = conf.apipassword;
  data.enable_pull_event = conf.enable_pull_event;
  data.enable_push_activity = conf.enable_push_activity;
  data.enable_push_patgames = conf.enable_push_patgames;

  data.feature.push = conf.push;

  if (checkUrl(conf.apiurl)) {
    data.api_url = conf.apiurl;
  }

  return data;
}